export const isMobile = () => {
    return (/Android|iPhone/i.test(navigator.userAgent))
}